import { Grid, Typography } from "@mui/material";
import ActionItem from "../ActionItem/ActionItem";
import ReturnModal from "./ReturnModal";
import { useContext, useState } from "react";
import {
  ApiResponseOkContext,
  AssetListContext,
} from "../../HardwareDetails/HardwareDetails";

export default function Return() {
  const [showReturnModal, setShowReturnModal] = useState(false);
  const assetList = useContext(AssetListContext);
  const apiResponseOk = useContext(ApiResponseOkContext);
  const showAlertNoAssetAssigned = () => {
    setShowReturnModal(false);
    const alertMessage =
      apiResponseOk == null
        ? "Please wait until your hardware data is loaded"
        : apiResponseOk
        ? "No Hardware assigned to you!"
        : "Oops! Looks like we’ve encountered some issue. Try refreshing the page or let us know through feedback.";
    alert(alertMessage);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography component={"h4"} variant={"h3"} color={"primary.main"}>
            Return
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <ActionItem
            label={"Hardware assigned to me"}
            onClick={() => setShowReturnModal(true)}
          />
        </Grid>
      </Grid>
      {assetList.length > 0 && (
        <ReturnModal
          assets={assetList}
          isOpen={showReturnModal}
          onClose={() => setShowReturnModal(false)}
        />
      )}
      {showReturnModal && assetList.length == 0 && showAlertNoAssetAssigned()}
    </>
  );
}
